module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-info common",
    class: [_vm.customClass ? _vm.customClass : 'primary'],
    style: ({
      width: _vm.width
    }),
    attrs: {
      "id": [_vm.id],
      "type": [_vm.type],
      "title": [_vm.title],
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.trackEvent
    }
  }, [_c('i', {
    class: [_vm.faIcon]
  }), (_vm.label) ? _c('span', [_vm._v(_vm._s(_vm.label))]) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4672dfff", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4672dfff"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/buttons/buttonPrimary/buttonPrimary.pug
// module id = 1408
// module chunks = 0